import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {InputGroup, FormControl, Button, Grid, Row, Label} from 'react-bootstrap';
import './../../editor/root-entry/RootEntry.css';
import {saveEntryForm, setPolyForm} from './EntryActions';
import {LexemeUtilities} from "../LexemeHelper";
import {SCSubmitButton} from "../../../../dict-components/components";


export class EntryEditForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newForm: this.props.item.title.entry_form
        };

        this._handleFormChange = this._handleFormChange.bind(this);
        this._handleKeyUp = this._handleKeyUp.bind(this);
        this._handleKeyUp = this._handleKeyUp.bind(this);
        this._handleSaveForm = this._handleSaveForm.bind(this);
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this.entryForm).focus();
    }

    _handleFormChange(evt) {
        var update = this.state;
        update.newForm = evt.target.value;
        this.setState(update);
    }

    _handleKeyUp(evt) {
        LexemeUtilities.handleKeyUp(evt, () => {
            saveEntryForm(this.state.newForm)
        });
    }

    _handleSaveForm() {
        saveEntryForm(this.state.newForm);
    }

    render() {

        return <Grid fluid>
            <Row>
                <InputGroup id={"loc-var-edit-group"}>
                    <FormControl type="text" placeholder={Dict.t('FORM') + "..."}
                                 ref={(input) => {
                                     this.entryForm = input;
                                 }}
                                 value={this.state.newForm}
                                 onChange={(evt) => this._handleFormChange(evt)}
                                 onKeyUp={this._handleKeyUp}/>
                    <SCSubmitButton onClick={this._handleSaveForm} text={Dict.t('SAVE')}/>
                </InputGroup>
            </Row>
        </Grid>;
    }
}